import {Component, AfterViewInit, Input} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as L from 'leaflet';
import {Globals} from '../globals';

const iconRetinaUrl = 'assets/marker-icon-2x.png';
const iconUrl = 'assets/marker-icon.png';
const shadowUrl = 'assets/marker-shadow.png';
const iconDefault = L.icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});
L.Marker.prototype.options.icon = iconDefault;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements AfterViewInit {
  @Input() selectedAirports: string = '';
  @Input() params: string = '';

  loading = false;
  data: any = null;
  private map: any;

  constructor(private globals: Globals, private http: HttpClient) { }

  ngAfterViewInit(): void {
    this.map = L.map('map', {
      center: [ 39.8282, -98.5795 ],
      zoom: 4
    });

    // // OpenStreetMap
    // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //   maxZoom: 18,
    //   minZoom: 3,
    //   attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    // }).addTo(this.map);

    // Mapbox
    L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiY2xlbWVudHpoYW5nIiwiYSI6ImNqeXh0b21xODExNXQzbW1pODB5dnI3MjkifQ.YX-3MFP9eLUYV_JbJl0_Fw', {
      maxZoom: 18,
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
        'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      id: 'mapbox/light-v11',
      tileSize: 512,
      zoomOffset: -1
    }).addTo(this.map);

    this.map.on('zoomend', ()=> {
      this.showCircles(this.params);
    });

    // Need to use setTimeout to avoid an error of loading status changed
    setTimeout(()=> {
      this.showCircles(this.params);
    })

  }

  scaledRadius(val: number, maxVal: number, zoomLevel: number): number {
    return 10 * (2**(zoomLevel-3)) * (val / maxVal);
  }

  color(code: string, selectedAirports: string): string {
    code = code.toUpperCase();
    if (code == selectedAirports.substring(0,3) || selectedAirports.indexOf(','+code) > 0) return 'orangered';

    if(selectedAirports.includes("*")) {
      // containing airport group
      let groups = selectedAirports.split(",");
      for(let i=0; i< groups.length; i++) {
        if(groups[i].endsWith("*")) {
          for(let j=0;  j<this.globals.airports.length; j++) {
            let obj = this.globals.airports[j];
            if(obj.code.toUpperCase() == groups[i].toUpperCase()) {
              // Group - .city contains the airport members
              if (code == obj.city.substring(0,3) || obj.city.indexOf(','+code) > 0) return 'orangered';
            }
          }
        }
      }
    }
    return 'royalblue';
  }

  /**
   * Refresh map with circles
   * @param map
   * @param selectedAirports
   * @param res
   */
  updateMap(map: L.Map, selectedAirports: string, res: any): void {
    const maxSize = Math.max(...res.features.map((x:any) => x.properties.SIZE), 0);

    // Clear all circles first
    map.eachLayer(function (layer: any) {
      if (layer.options) {
        if(layer.options.radius != undefined) map.removeLayer(layer);
      }
    });

    for (const c of res.features) {
      const lon = c.geometry.coordinates[0];
      const lat = c.geometry.coordinates[1];
      let color = this.color(c.properties.CODE, selectedAirports);
      const circle = L.circleMarker([lat, lon],{
        radius: this.scaledRadius(c.properties.SIZE, maxSize, map.getZoom()),
        color: color
      });

      let label = "<table><tr><td><b>Airport Code:</b> </td><td style='color:" + color + "'><b>" + c.properties.CODE + "</b></td></tr>"
        + "<tr><td><b>Airport Name:</b></td><td>" + c.properties.NAME + "</td></tr>"
        + "<tr><td><b>City Name:</b></td><td>" + c.properties.CITY + ", " + c.properties.STATE + "</td></tr>"
        + "<tr><td><b>Passengers:</b></td><td>" + this.globals.commaFormat(c.properties.SIZE) + "</td></tr></table>";
      circle.bindTooltip(label);

      circle.addTo(map);
    }
  }

  /**
   * Show circles on a map. Get data from backend if it is null.
   * @param map
   * @param selectedAirports
   */
  showCircles(params: string): void {
    if (this.data == null) {
      this.loading = true;
      this.http.get(this.globals.url_root + "/GeoContent.action?sql=SQL_TSA_AIRPORT_SIZE" + params).subscribe((res: any) => {
        this.data = res;
        this.updateMap(this.map, this.selectedAirports, res);
        this.loading = false;
      });
    } else {
      this.loading = true;
      this.updateMap(this.map, this.selectedAirports, this.data);
      this.loading = false;
    }
  }

  clearData() {
    this.data = null;
  }
}
